import { useEffect, useState } from "react";
import CloseIcon from "../assets/crossIcon.svg";
import { RpaServices } from "../services/RpaServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { CircularProgress } from "@mui/material";
import MoveToNextStage from "../dashboard/cases/editCases/MoveToNextStage";
import { CaseServices } from "../services/CaseServices";
const AddPmjayQuery = ({ selectedRpaLog, setProceedClicked, fetchrpaLogs }) => {
  const [queryDetails, setQueryDetails] = useState("");
  const [pmjayStatus, setPmjayStatus] = useState("");
  const [saving, setSaving] = useState(false);
  const [latestStage, setLatestStage] = useState(null);
  const [nextPossibleStages, setNextPossibleStage] = useState(null);
  const [approvedClick, setApprovedClick] = useState(false);
  const [pmjayDateTime, setPmjayDateTime] = useState("");
  // const [deadline, setDeadline] = useState("");

  function toISOStringWithTimezone(localDateTimeStr) {
    if (!localDateTimeStr) return null;
    const date = new Date(localDateTimeStr);
    return date.toISOString();
  }

  const handleAddQuery = async () => {
    if (!pmjayStatus.trim() || !pmjayDateTime || !queryDetails.trim()) {
      window.alert(
        "Pmjay Status, Date & Time, and Pmjay Query are required fields",
      );
      return;
    }

    setSaving(true);
    const data = selectedRpaLog?.pmjayRegistrationId
      ? {
          pmjayRegistrationId: selectedRpaLog.pmjayRegistrationId,
          pmjayStatus: pmjayStatus,
          queryMessage: queryDetails,
          // deadline: deadline,
        }
      : {
          pmjayId: selectedRpaLog.pmjayCaseId,
          pmjayStatus: pmjayStatus,
          queryMessage: queryDetails,
          // deadline: deadline,
        };
    data.tmsStageUpdateTime = toISOStringWithTimezone(pmjayDateTime);

    try {
      const res = await RpaServices.addPmjayQuery(data);
      window.alert(res?.data?.message);
      await fetchrpaLogs("Pending");
      setProceedClicked(null);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSaving(false);
  };

  const handleApproved = async () => {
    setSaving(true);
    const data = selectedRpaLog?.pmjayRegistrationId
      ? {
          pmjayRegistrationId: selectedRpaLog.pmjayRegistrationId,
          pmjayStatus: pmjayStatus,
          queryMessage: queryDetails,
        }
      : {
          pmjayId: selectedRpaLog.pmjayCaseId,
          pmjayStatus: pmjayStatus,
          queryMessage: queryDetails,
        };
    try {
      if (pmjayStatus) {
        const res = await RpaServices.addPmjayQuery(data);
        window.alert(res?.data?.message);
        await fetchrpaLogs("Pending");
        setProceedClicked(null);
      } else {
        window.alert("Pmjay Status is required field");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setSaving(false);
  };
  const handleRpaRequestStatus = async () => {
    const data = {
      requestId: selectedRpaLog?.id,
      requestStatus: "COMPLETED",
      oldStatus: selectedRpaLog?.oldRequestStatus,
      statusRemark: "Manually Updated",
    };

    try {
      const response = await RpaServices.updateRpaRequest(data);
      if (response?.status === 200) {
        alert("Changes saved successfully!");
        await fetchrpaLogs("Pending");
        setProceedClicked(null);
      } else {
        alert("Failed to update rpa details.");
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(
        selectedRpaLog?.caseId,
      );
      setLatestStage(response.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getNextPossibleStage = async () => {
    try {
      const response = await CaseServices.getNextPossibleSubStages(
        latestStage?.currnetSubMasterStage[0]?.commandCenterStage,
      );
      setNextPossibleStage(response.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  // useEffect(() => {
  //   document.body.style.overflow = "hidden";
  //   getLatestCaseStage();
  //   return () => {
  //     document.body.style.overflow = "auto";
  //   };
  // }, []);

  useEffect(() => {
    if (!selectedRpaLog?.caseId) return;
    document.body.style.overflow = "hidden";
    getLatestCaseStage();
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedRpaLog?.caseId]);

  useEffect(() => {
    latestStage && getNextPossibleStage();
  }, [latestStage]);

  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center bg-[#017C5780] z-[1201]">
      <div className="relative w-full max-w-[420px] mx-4 bg-white rounded-[20px] p-6 shadow-xl">
        {/* Header buttons */}
        <div className="absolute top-4 right-5 flex gap-2 cursor-pointer z-20">
          <div
            className="text-sm font-semibold uppercase text-[#017C57] bg-white border-2 border-[#017C57] border-solid py-3 px-8 rounded-full cursor-pointer"
            onClick={() => setApprovedClick(true)}
          >
            Approved
          </div>
          <img
            src={CloseIcon}
            alt="close-icon"
            onClick={() => setProceedClicked(null)}
          />
        </div>
        {/* Add top padding here */}
        <div className="flex flex-col items-center gap-4 pt-24">
          {/* Your inputs and Add Query button... */}
          <input
            type="text"
            placeholder="Enter Pmjay Status"
            className="w-full max-w-[350px] p-4 rounded-[8px] border border-gray-300"
            onChange={(e) => setPmjayStatus(e.target.value)}
          />
          <input
            type="datetime-local"
            placeholder="Enter Date and Time"
            className="w-full max-w-[350px] p-4 rounded-[8px] border border-gray-300"
            onChange={(e) => {
              const selectedDate = new Date(e.target.value);

              // const deadlineDate = new Date(selectedDate);
              // deadlineDate.setDate(deadlineDate.getDate() + 15);

              setPmjayDateTime(e.target.value);
              // setDeadline(deadlineDate);
            }}
          />
          <textarea
            name="query"
            id="query"
            placeholder="Enter Pmjay Query"
            className="w-full max-w-[350px] h-[100%] p-4 rounded-[8px] border border-gray-300"
            onChange={(e) => setQueryDetails(e.target.value)}
          />
          <div className="flex flex-wrap justify-center items-center gap-4 max-w-full">
            {saving ? (
              <CircularProgress />
            ) : (
              <div
                className="text-sm font-semibold uppercase text-white bg-[#017C57] py-3 px-8 rounded-full cursor-pointer whitespace-nowrap w-full max-w-[200px] mx-auto"
                onClick={handleAddQuery}
                style={{ textAlign: "center" }}
              >
                Add Query
              </div>
            )}
          </div>
        </div>
      </div>

      {approvedClick && (
        <MoveToNextStage
          setNextStage={setApprovedClick}
          caseId={selectedRpaLog?.caseId}
          handleRpaRequestStatus={handleRpaRequestStatus}
        />
      )}
    </div>
  );
};

export default AddPmjayQuery;
